import { createSlice } from "@reduxjs/toolkit";
import {
  getSixthFlow,
  createSixthFlow,
  updateSixthFlow,
  deleteSixthFlow,
  clearLocalActiveSixthFlow
} from './actions';

export const initialState = {
  sixthFlow: { id: '', email: '', sixth_prompts: [], updated_at: '' },
  loading: false
};

const slice = createSlice({
  name: 'sixthFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getSixthFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSixthFlow.fulfilled, (state, action) => {
        const { sixth_flow } = action.payload;
        const sixthFlow = { ...state.sixthFlow, ...sixth_flow };
        
        state.loading = false;
        state.sixthFlow = sixthFlow;
      })
      .addCase(getSixthFlow.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createSixthFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSixthFlow.fulfilled, (state, action) => {
        const { sixth_flow } = action.payload;
        
        state.loading = false;
        state.sixthFlow = sixth_flow;       
      })
      .addCase(createSixthFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateSixthFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSixthFlow.fulfilled, (state, action) => {
        const { status, sixth_flow } = action.payload;
        const updatedSixthFlow = { ...state.sixthFlow, ...sixth_flow };
        
        state.loading = false;
        if (status === 204) state.sixthFlow = updatedSixthFlow;       
      })
      .addCase(updateSixthFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteSixthFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSixthFlow.fulfilled, (state, action) => {
        const { status } = action.payload;
        
        state.loading = false;
        if (status === 204) state.sixthFlow = initialState.sixthFlow;       
      })
      .addCase(deleteSixthFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveSixthFlow, state => {
        state.sixthFlow = initialState.sixthFlow;
      })
  }
})

export default slice.reducer;